import axios from "axios";
import { getApiBase } from "../apiBase";
import { emitMarketplaceRewardFromResponse } from "./marketplaceRewards";

function baseUrl(apiUrl) {
  return apiUrl || getApiBase();
}

export async function fetchContracts({ apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.get(`${baseUrl(apiUrl)}/contracts`, {
    headers: getAuthHeaders?.(),
  });
  return Array.isArray(data) ? data : [];
}

export async function fetchContractorOptions({ apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.get(`${baseUrl(apiUrl)}/contracts/contractor-options`, {
    headers: getAuthHeaders?.(),
  });
  return Array.isArray(data) ? data : [];
}

export async function fetchProjectContractFields(projectId, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.get(`${baseUrl(apiUrl)}/projects/${projectId}/contract-fields`, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function fetchBatchProjectContractFields(projectIds, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.post(
    `${baseUrl(apiUrl)}/contracts/project-fields-batch`,
    { projectIds },
    { headers: getAuthHeaders?.() }
  );
  return data;
}

export async function fetchContract(id, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.get(`${baseUrl(apiUrl)}/contracts/${id}`, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function createContract(body, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.post(`${baseUrl(apiUrl)}/contracts`, body, {
    headers: getAuthHeaders?.(),
  });
  emitMarketplaceRewardFromResponse(data);
  return data;
}

export async function updateContract(id, body, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.patch(`${baseUrl(apiUrl)}/contracts/${id}`, body, {
    headers: getAuthHeaders?.(),
  });
  emitMarketplaceRewardFromResponse(data);
  return data;
}

export async function setContractProjects(id, projectLinksOrIds, { apiUrl, getAuthHeaders } = {}) {
  const body = Array.isArray(projectLinksOrIds)
    ? typeof projectLinksOrIds[0] === "object"
      ? { projectLinks: projectLinksOrIds }
      : { projectIds: projectLinksOrIds }
    : projectLinksOrIds && typeof projectLinksOrIds === "object"
      ? projectLinksOrIds
      : { projectIds: [] };
  const { data } = await axios.put(`${baseUrl(apiUrl)}/contracts/${id}/projects`, body, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function deleteContract(id, { apiUrl, getAuthHeaders } = {}) {
  await axios.delete(`${baseUrl(apiUrl)}/contracts/${id}`, {
    headers: getAuthHeaders?.(),
  });
}

export function contractTemplateDownloadUrl(id, apiUrl) {
  return `${baseUrl(apiUrl)}/contracts/${id}/template`;
}

export function contractExecutedFileUrl(id, apiUrl) {
  return `${baseUrl(apiUrl)}/contracts/${id}/executed-file/content`;
}

export function contractWinningBidFileUrl(id, apiUrl) {
  return `${baseUrl(apiUrl)}/contracts/${id}/winning-bid-file/content`;
}

export function contractPermitFilesZipUrl(id, apiUrl) {
  return `${baseUrl(apiUrl)}/contracts/${id}/permit-files.zip`;
}

export async function uploadExecutedContractFile(id, file, { apiUrl, getAuthHeaders } = {}) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await axios.post(`${baseUrl(apiUrl)}/contracts/${id}/executed-file`, form, {
    headers: {
      ...getAuthHeaders?.(),
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
}

export async function uploadWinningBidFile(id, file, { apiUrl, getAuthHeaders } = {}) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await axios.post(`${baseUrl(apiUrl)}/contracts/${id}/winning-bid-file`, form, {
    headers: {
      ...getAuthHeaders?.(),
      "Content-Type": "multipart/form-data",
    },
  });
  return data;
}

export async function createContractAdjustment(id, body, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.post(`${baseUrl(apiUrl)}/contracts/${id}/adjustments`, body, {
    headers: getAuthHeaders?.(),
  });
  return data;
}

export async function deleteContractAdjustment(id, adjustmentId, { apiUrl, getAuthHeaders } = {}) {
  const { data } = await axios.delete(
    `${baseUrl(apiUrl)}/contracts/${id}/adjustments/${adjustmentId}`,
    { headers: getAuthHeaders?.() }
  );
  return data;
}

export function contractAdjustmentSupportFileUrl(id, adjustmentId, apiUrl) {
  return `${baseUrl(apiUrl)}/contracts/${id}/adjustments/${adjustmentId}/support-file/content`;
}

export async function uploadAdjustmentSupportFile(
  id,
  adjustmentId,
  file,
  { apiUrl, getAuthHeaders } = {}
) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await axios.post(
    `${baseUrl(apiUrl)}/contracts/${id}/adjustments/${adjustmentId}/support-file`,
    form,
    {
      headers: {
        ...getAuthHeaders?.(),
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return data;
}
